<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="choiceprodpricegrps_new" ttGoto="choiceprodpricegrp" [ttGotoParms]="{ choiceprodpricegrp_keyono: '0', prod_id_choice: prodId }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListPriceGroups"></tt-list>
</tt-page>
